<template>
    <b-card
    header-bg-variant="primary"
    header-class="py-2 px-3 text-white"
    body-class="p-3"
    footer-class="py-2 px-3"
    class="mx-0">
    <template #header>

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-1 bi bi-grid-fill" viewBox="0 0 16 16"><path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z"/></svg>
        Other Loan
        <a href="javascript:void(0)" @click="$emit('remove-product-application', product_application.pcom_id)" class="position-absolute cursor-pointer" style="right: -14px; top: -7px;" v-if="is_editable">
            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="20" height="20" viewBox="0 0 512 512">
                <circle fill="#DF3030" cx="256" cy="256" r="256" />
                <g fill="#fff" transform="translate(148, 116) scale(0.55)">
                    <path fill="#fff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/>
                </g>
            </svg>
        </a>
    </template>

    <!--Card Body -->
    <div class="my-2">
        <p class="text-xs text-muted">Product</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_json.prod_oth_type }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Product Details</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_json.prod_oth_detail }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Product Value</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_project_json.prod_oth_value | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Arrangement Fee</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_project_json.prod_oth_agreement_rate | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Arrangement Fee SST</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_json.prod_oth_agreement_rate_sst }}%</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Total Arrangement Fee</p>
        <p class="font-weight-600">RM{{ product_application.pcom_product_detail.pcp_project_json.prod_oth_agreement_fees | moneyFormatter }}</p>
    </div>
    <div class="my-2">
        <p class="text-xs text-muted">Payment Mode</p>
        <p class="font-weight-600">{{ product_application.pcom_product_detail.pcp_project_json.prod_oth_pay_mode }}</p>
    </div>
</b-card>
</template>
<script>

export default {
    props:['product_application', 'is_editable']
}
</script>